// extracted by mini-css-extract-plugin
module.exports = {"meetingJoinButtonContainer":"JoinMeetingButton_meetingJoinButtonContainer__bZ2CZ","meetingJoinButton":"JoinMeetingButton_meetingJoinButton__Zesty"};